import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import EventCalendarView from './views/EventCalendarView';

const EventRequestQueue = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Temporary sample events
    const sampleEvents = [
      {
        id: 1,
        title: 'Board Meeting',
        description: 'Quarterly board meeting to discuss strategy',
        type: 'meeting',
        startDate: '2024-02-15T10:00:00',
        endDate: '2024-02-15T12:00:00',
        location: 'Conference Room A'
      },
      {
        id: 2,
        title: 'Tax Filing Deadline',
        description: 'Annual tax return submission',
        type: 'filing',
        startDate: '2024-02-20T09:00:00',
        endDate: '2024-02-20T17:00:00'
      },
      {
        id: 3,
        title: 'Fundraising Gala',
        description: 'Annual fundraising event',
        type: 'fundraising',
        startDate: '2024-02-25T18:00:00',
        endDate: '2024-02-25T22:00:00',
        location: 'Grand Ballroom'
      }
    ];

    setEvents(sampleEvents);
    setLoading(false);
  }, []);

  const handleAddEvent = async (eventData) => {
    try {
      // Add API call here
      const newEvent = { ...eventData };
      setEvents(prev => [...prev, newEvent]);
    } catch (error) {
      console.error('Error adding event:', error);
    }
  };

  const handleUpdateEvent = async (eventData) => {
    try {
      // Add API call here
      setEvents(prev => prev.map(event => 
        event.id === eventData.id ? eventData : event
      ));
    } catch (error) {
      console.error('Error updating event:', error);
    }
  };

  const handleDeleteEvent = async (eventId) => {
    try {
      // Add API call here
      setEvents(prev => prev.filter(event => event.id !== eventId));
    } catch (error) {
      console.error('Error deleting event:', error);
    }
  };

  if (loading) {
    return <Box>Loading...</Box>;
  }

  return (
    <Box sx={{ p: 2 }}>
      <EventCalendarView 
        events={events}
        onAddEvent={handleAddEvent}
        onUpdateEvent={handleUpdateEvent}
        onDeleteEvent={handleDeleteEvent}
      />
    </Box>
  );
};

export default EventRequestQueue;